var appMarketplace = angular.module('appMarketplace');
appMarketplace.factory('sessionExpiredInterceptor', ['$q', '$window', '$injector',
                                                    function ($q, $window, $injector) {
    function onUnauthorisedError(promise) {
        var NavigationService = $injector.get('NavigationService');
        NavigationService.getResolvedCurrentAccount(
            function resolvedCallback(account) {
                var $compile = $injector.get('$compile');
                var $rootScope = $injector.get('$rootScope');
                var scope = $rootScope.$new();
                scope.promise = promise;
                var sessionExpiredPopup = $compile("<session-expired promise='promise'></session-expired>")(scope);
                angular.element(document.body).append(sessionExpiredPopup);
            },
            function notResolvedCallback() {
                $window.location.href = $injector.get('UrlService').createAbsoluteUrl('/useradmin/login.html/expired');
            }
        );
    }

    // 1) jquery prefilter for kendo datasources
    $.ajaxPrefilter(function (options, originalOptions, jqXHR) {
        // save the original error callback for later
        if (originalOptions.error)
            originalOptions._error = originalOptions.error;

        // overwrite *current request* error callback
        options.error = $.noop();

        // setup our own deferred object to also support promises that are only invoked
        // once all of the retry attempts have been exhausted
        var dfd = $.Deferred();
        jqXHR.done(dfd.resolve);

        // if the request fails, do something else yet still resolve
        jqXHR.fail(function () {
            var args = Array.prototype.slice.call(arguments);

            if (jqXHR.status === 401) {
                onUnauthorisedError(dfd);

                dfd.then(function () {
                    return $.ajax(originalOptions);
                });
            } else {
                // add our _error callback to our promise object
                if (originalOptions._error)
                    dfd.fail(originalOptions._error);
                dfd.rejectWith(jqXHR, args);
            }
        });

        // NOW override the jqXHR's promise functions with our deferred
        return dfd.promise(jqXHR);
    });

    // 2) angular interceptor
    return {
        responseError: function (error) {
            if (error.status === 401 && !error.config.url.endsWith('/rest/auth/login')) {
                var $http = $injector.get('$http');

                // When the session recovered, make the same backend call again and chain the request
                var deferred = $q.defer();
                onUnauthorisedError(deferred);

                return deferred.promise.then(function () {
                    return $http(error.config);
                });
            }
            return $q.reject(error);
        }
    }
}]);


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/js/main/interceptors/session-expired-interceptor.js
// module id = 261
// module chunks = 37